module.exports = __webpack_public_path__ + "img/telemedicina-humana.77e3425e.jpeg";